import {
  TealiumEventParentGroup,
  IGetEventGroupProps,
  tealiumEventParentGroupPrefix,
} from '@4tn/core-audio-player-shared';

export class TealiumEventParent implements IGetEventGroupProps {
  private readonly parent_hostname?: string = document.referrer || document.location.hostname;

  public getEventGroupProps(): TealiumEventParentGroup {
    const groupKeys = Object.keys(this).filter((k) => k.startsWith(tealiumEventParentGroupPrefix));
    const eventGroupProps = groupKeys.reduce((o, k) => Object.assign(o, { [k]: this[k] }), {});
    return eventGroupProps as TealiumEventParentGroup;
  }
}
